 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import useAtmosphere from '../hooks/useAtmosphere'
import useRouter from '../hooks/useRouter'
import SetNotificationStatusMutation from '../mutations/SetNotificationStatusMutation'
import mapTeamsLimitExceededToToast from '../mutations/toasts/mapTeamsLimitExceededToToast'
import mapTeamsLimitReminderToToast from '../mutations/toasts/mapTeamsLimitReminderToToast'
import mapPromptToJoinOrgToToast from '../mutations/toasts/mapPromptToJoinOrgToToast'
import mapRequestToJoinOrgToToast from '../mutations/toasts/mapRequestToJoinOrgToToast'








const typePicker

 = {
  TEAMS_LIMIT_EXCEEDED: mapTeamsLimitExceededToToast,
  TEAMS_LIMIT_REMINDER: mapTeamsLimitReminderToToast,
  PROMPT_TO_JOIN_ORG: mapPromptToJoinOrgToToast,
  REQUEST_TO_JOIN_ORG: mapRequestToJoinOrgToToast
}

const PinnedSnackbarNotifications = ({queryRef}) => {
  const data = useFragment(
    graphql`
      fragment PinnedSnackbarNotifications_query on Query {
        viewer {
          pinnedNotifications: notifications(
            first: 10
            types: [
              TEAMS_LIMIT_EXCEEDED
              TEAMS_LIMIT_REMINDER
              PROMPT_TO_JOIN_ORG
              REQUEST_TO_JOIN_ORG
            ]
          ) {
            edges {
              node {
                id
                status
                type
                ...mapTeamsLimitExceededToToast_notification @relay(mask: false)
                ...mapTeamsLimitReminderToToast_notification @relay(mask: false)
                ...mapPromptToJoinOrgToToast_notification @relay(mask: false)
                ...mapRequestToJoinOrgToToast_notification @relay(mask: false)
              }
            }
          }
        }
      }
    `,
    queryRef
  )
  const {history} = useRouter()
  const atmosphere = useAtmosphere()
  const {viewer} = data
  const notifications = _optionalChain([viewer, 'optionalAccess', _ => _.pinnedNotifications]) || {edges: []}
  const {edges} = notifications
  const snackbarNotifications = edges.filter(
    ({node}) => node.status === 'UNREAD' && Object.keys(typePicker).includes(node.type)
  )

  React.useEffect(() => {
    snackbarNotifications.forEach(({node}) => {
      const specificNotificationToastMapper = typePicker[node.type]
      if (!specificNotificationToastMapper) {
        return
      }

      const notificationSnack = specificNotificationToastMapper(node, {
        atmosphere,
        history
      })

      if (!notificationSnack) {
        return
      }

      const callback = notificationSnack.onManualDismiss
      notificationSnack.onManualDismiss = () => {
        const {id: notificationId} = node
        SetNotificationStatusMutation(
          atmosphere,
          {
            notificationId,
            status: 'CLICKED'
          },
          {}
        )

        _optionalChain([callback, 'optionalCall', _2 => _2()])
      }

      atmosphere.eventEmitter.emit('addSnackbar', notificationSnack)
    })
  }, [])

  return null
}

export default PinnedSnackbarNotifications
